import { render } from "./Divider.vue?vue&type=template&id=e1296642&scoped=true"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"

import "./Divider.vue?vue&type=style&index=0&id=e1296642&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e1296642"

export default script